import React from "react";
import { connect } from "react-redux";
import { RootState } from "../../redux";
import { Notification } from "../../redux/modules/notifications";
import "./index.css";

type NotificationProps = {
  notifications?: Notification[];
};

class NotificationList extends React.Component<NotificationProps> {
  getNotificationIcon = (type: string) => {
    switch (type) {
      case "success":
        return "✅";
      case "danger":
        return "❌";
      case "warning":
        return "⚠️";
      default:
        return "ℹ️";
    }
  };

  renderNotifications() {
    if (!this.props.notifications || this.props.notifications.length === 0) {
      return null;
    }
    return this.props.notifications.map((n) => {
      return (
        <div className={`notification notification--${n.type}`} role="alert" key={n.id}>
          <div className="notification__content">
            <span className="notification__icon">{this.getNotificationIcon(n.type)}</span>
            <span className="notification__message">{n.message}</span>
          </div>
        </div>
      );
    });
  }

  render() {
    return <div className="notifications-container">{this.renderNotifications()}</div>;
  }
}

const mapStateToProps = (state: RootState) => {
  return { notifications: state.notifications };
};

export default connect(mapStateToProps, {})(NotificationList);
